module.exports = "/assets/data/020fbe3c01a0f649ae9c4002710b89d3-PO3.data.json";